import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { WhatsAppChatDialog } from "./WhatsAppChatDialog";

interface WhatsAppButtonProps {
  phone?: string | null;
  name?: string;
  leadId?: string;
  contactId?: string;
  dealId?: string;
  /** "icon" (small round button) or "label" (logo + "WhatsApp") */
  variant?: "icon" | "label";
  className?: string;
}

/** Opens the CRM WhatsApp chat for a phone number. Hidden without a phone or the whatsapp.send permission. */
export function WhatsAppButton({ phone, name, leadId, contactId, dealId, variant = "icon", className }: WhatsAppButtonProps) {
  const { hasPermission } = useAuth();
  const [open, setOpen] = useState(false);
  if (!phone || !hasPermission("whatsapp.send")) return null;

  return (
    <>
      <button
        type="button"
        title={`WhatsApp ${name || phone}`}
        aria-label={`Open WhatsApp chat with ${name || phone}`}
        onClick={(e) => {
          // Rows that open a record on click must not react to this button
          e.stopPropagation();
          setOpen(true);
        }}
        className={cn(
          variant === "icon"
            ? "inline-flex size-6 items-center justify-center rounded-full hover:bg-[#25D366]/15"
            : "inline-flex items-center gap-1.5 rounded-md border border-[#25D366]/40 bg-[#25D366]/10 px-2 py-1 text-xs font-medium text-[#128C7E] hover:bg-[#25D366]/20 dark:text-[#25D366]",
          className
        )}
      >
        <WhatsAppIcon className={variant === "icon" ? "size-3.5" : "size-4"} />
        {variant === "label" && "WhatsApp"}
      </button>
      {open && (
        <span onClick={(e) => e.stopPropagation()}>
          <WhatsAppChatDialog open={open} onOpenChange={setOpen} phone={phone} name={name} leadId={leadId} contactId={contactId} dealId={dealId} />
        </span>
      )}
    </>
  );
}
